import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import courrier from './slices/courrierSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        courrier,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
